import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { useBackendHealth } from "@/hooks/useBackendHealth";

const NetworkWatcher: React.FC = () => {
  const browserOnline = useNetworkStatus();
  const backendOnline = useBackendHealth();

  const navigate = useNavigate();
  const location = useLocation();

  const lastPathRef = useRef(location.pathname);
  const [ready, setReady] = useState(false);

  // evita flash inicial
  useEffect(() => {
    const id = setTimeout(() => setReady(true), 50);
    return () => clearTimeout(id);
  }, []);

  // 🌐 estado global
  const isOnline = browserOnline && backendOnline;

  // 🧠 guardar última ruta
  useEffect(() => {
    if (isOnline && location.pathname !== "/offline") {
      lastPathRef.current = location.pathname;
    }
  }, [isOnline, location.pathname]);

  // 🚨 ir offline
  useEffect(() => {
    if (!isOnline && location.pathname !== "/offline") {
      navigate("/offline", { replace: true });
    }
  }, [isOnline, location.pathname, navigate]);

  // 🔄 volver
  useEffect(() => {
    if (isOnline && location.pathname === "/offline") {
      navigate(lastPathRef.current || "/", { replace: true });
    }
  }, [isOnline, location.pathname, navigate]);

  if (!ready) return null;

  return null;
};

export default NetworkWatcher;